import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Navbar from '../components/navBar';
import Footer from '../components/footer';

// Public "how to delete your account" page (Google Play requires a web link
// that explains account deletion without needing the app). Prerendered.
function DeleteAccountPage() {
    return (
        <div className="font-noto-sans-jp min-h-screen bg-mainBackgroundColor flex flex-col">
            <Helmet>
                <title>Delete your account | OniKanji</title>
                <meta name="description" content="How to permanently delete your OniKanji account and data." />
                <link rel="canonical" href="https://onikanji.com/delete-account" />
            </Helmet>
            <Navbar />
            <main className="flex-1 w-full max-w-2xl mx-auto px-4 py-10 sm:py-14">
                <h1 className="text-3xl font-bold text-logoColor mb-3">Delete your OniKanji account</h1>
                <p className="text-gray-700 mb-8">
                    You can delete your account at any time, from the website or the Android app. Deleting it is permanent.
                </p>

                <section className="bg-white rounded-lg shadow-blueBoxShadow p-5 sm:p-6 mb-6">
                    <h2 className="text-xl font-bold text-logoColor mb-3">Delete it yourself</h2>
                    <ol className="list-decimal pl-5 space-y-2 text-gray-800">
                        <li>Sign in at <Link to="/login" className="text-darkBlueColor underline">onikanji.com</Link> or in the OniKanji app.</li>
                        <li>Open the menu and go to <strong>My Profile</strong>.</li>
                        <li>Scroll to <strong>Delete Account</strong>, type your public username to confirm, and tap <strong>Delete Account</strong>.</li>
                    </ol>
                </section>

                <section className="bg-white rounded-lg shadow-blueBoxShadow p-5 sm:p-6 mb-6">
                    <h2 className="text-xl font-bold text-logoColor mb-3">Or ask us to do it</h2>
                    <p className="text-gray-800">
                        Email <strong className="select-all">khalid@onikanji.com</strong> from the address on your account with the subject
                        “Delete my account”. We delete it within 7 days and reply to confirm.
                    </p>
                </section>

                <section className="bg-white rounded-lg shadow-blueBoxShadow p-5 sm:p-6">
                    <h2 className="text-xl font-bold text-logoColor mb-3">What gets deleted</h2>
                    <ul className="list-disc pl-5 space-y-1.5 text-gray-800">
                        <li>Your account, username and email address</li>
                        <li>Your study progress, reviews, stats and leaderboard entries</li>
                        <li>Your email preferences, review-reminder subscriptions and uploaded content</li>
                    </ul>
                    <p className="text-gray-600 text-sm mt-4">
                        Deleting your account also cancels any active subscription, so you won't be billed again. Payment records for past
                        purchases are kept by our payment processor (Stripe) for tax and accounting, as the law requires.
                    </p>
                </section>
            </main>
            <Footer />
        </div>
    );
}

export default DeleteAccountPage;
